<template>
  <div>
    <div
      class="subform-row d-flex justify-content-between gap-1"
      data-test-subform-row
      v-for="(row, rowIdx) in rows"
      :key="row.rowUid"
    >
      <sub-form-row
        class="w-100"
        :path="`${path}/${rowIdx}`"
        :key="`${row.rowUid}-comp`"
        :row-id="rowIdx"
        :list-head="listHead"
        :read-only="readOnly"
        :row-index="rowIdx"
        :name="name"
        @remove-row-click="onRemoveRowClick"
      />
      <div class="listview-buttons" v-if="isListView">
        <el-button
          v-if="showEditButton"
          type="primary"
          :data-test-edit-subform-row="name"
          @click.stop="onEditRowClick(rowIdx)"
          icon="el-icon-edit"
          >{{ $i18n.t('Edit') }}
        </el-button>
        <el-button
          v-if="showRemoveButton"
          type="danger"
          :data-test-remove-subform-row="name"
          @click.stop="onRemoveRowClick(rowIdx)"
          icon="el-icon-delete"
        />
      </div>
      <div v-else-if="isFormGridView">
        <el-button
          v-if="showRemoveButton"
          type="danger"
          size="medium"
          :data-test-remove-subform-row="name"
          @click.stop="onRemoveRowClick(rowIdx)"
          icon="el-icon-delete"
        />
      </div>
      <div v-else-if="!isCollapsibleFormGridView" class="default-buttons">
        <el-button
          v-if="showRemoveButton"
          type="danger"
          :data-test-remove-subform-row="name"
          @click.stop="onRemoveRowClick(rowIdx)"
          icon="el-icon-delete"
        />
      </div>
    </div>
  </div>
</template>

<script>
import subFormViewMixin from './mixin-sub-form-view'

export default {
  name: 'SubFormGridView',
  mixins: [subFormViewMixin],
  props: ['isReadView'],
}
</script>

<style scoped lang="scss">
.subform-row {
  flex-wrap: nowrap;
  .listview-buttons {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    flex-wrap: nowrap;
    gap: 5px;
  }
  .default-buttons {
    display: flex;
    align-items: flex-end;
  }
}
.subform-row:nth-child(even) {
  background-color: $table-header;
}
</style>
